import { EuiCheckbox, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiText, htmlIdGenerator } from '@elastic/eui';
import { isEmpty } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';

const ChoiceExpose = ({ index, control, setValue, watch, field }) => {
    const orderingModes = useSelector((state) => state.menuReducer.restaurantOrderingModes);
    const itemOrderingModes = useWatch({
        control,
        name: `choices[${index}].ordering_modes`,
    });
    const [orderingModeState, setOrderingModeState] = useState([]);
    const [removedOrderingModes, setRemovedOrderingModes] = useState([]);

    const updateOrderingMode = useCallback(
        (mode, event) => {
            const doesHaveDifferentPrices = watch(
                `choices[${index}].is_enabled_same_price_details_for_all_ordering_modes`
            );
            let selectedMode = {};
            selectedMode = {
                compare_price: !doesHaveDifferentPrices ? orderingModeState?.[0]?.compare_price : null,
                gst_slab: !doesHaveDifferentPrices ? orderingModeState?.[0]?.gst_slab : null,
                packaging_charge: !doesHaveDifferentPrices ? orderingModeState?.[0]?.packaging_charge : null,
                price: !doesHaveDifferentPrices ? orderingModeState?.[0]?.price : null,
                [`price_${mode.id}`]: !doesHaveDifferentPrices ? orderingModeState?.[0]?.price : null,
                restaurant_ordering_mode_id: mode?.id,
                restaurant_ordering_mode_name: mode?.display_name,
            };
            const isChecked = event.target.checked;

            if (!isChecked) {
                // removed ordering mode
                const doesModeExisted = field?.ordering_modes?.filter(
                    (mode) => mode.restaurant_ordering_mode_id === selectedMode.restaurant_ordering_mode_id
                )?.[0];
                if (!isEmpty(doesModeExisted)) {
                    setRemovedOrderingModes([...removedOrderingModes, doesModeExisted?.restaurant_ordering_mode_id]);
                    const updatedOrderingMode = orderingModeState.filter(
                        (mode) => mode.restaurant_ordering_mode_id !== selectedMode.restaurant_ordering_mode_id
                    );
                    if (updatedOrderingMode.length) {
                        setOrderingModeState(updatedOrderingMode);
                        setValue(`choices[${index}].ordering_modes`, updatedOrderingMode);
                    }
                    setValue(`delete_ordering_modes`, [
                        ...removedOrderingModes,
                        doesModeExisted?.restaurant_ordering_mode_id,
                    ]);
                } else {
                    const removedFromOrderingState = orderingModeState.filter(
                        (mode) => mode.restaurant_ordering_mode_id !== selectedMode.restaurant_ordering_mode_id
                    );
                    setOrderingModeState(removedFromOrderingState);
                    setValue(`choices[${index}].ordering_modes`, removedFromOrderingState);
                }
            } else {
                setOrderingModeState((prevState) => [...prevState, selectedMode]);

                // check if the id is in removeState
                const destroyFromRemoveState = removedOrderingModes?.filter(
                    (id) => id != selectedMode.restaurant_ordering_mode_id
                );
                setRemovedOrderingModes(destroyFromRemoveState);
                setValue(`delete_ordering_modes`, destroyFromRemoveState);
                setValue(`choices[${index}].ordering_modes`, [...orderingModeState, selectedMode]);
                // setOrderingModeState([...orderingModeState, modeComeBack]);
            }
        },
        [field, index, orderingModeState, removedOrderingModes, setValue, watch]
    );

    useEffect(() => {
        if (itemOrderingModes?.length) {
            setOrderingModeState(itemOrderingModes);
        }
    }, [itemOrderingModes, watch]);

    return (
        <>
            <EuiText style={{ fontWeight: 500 }} size='s'>
                Choices Expose
            </EuiText>
            <EuiFlexGroup
                alignItems='center'
                style={{ margin: '0 auto' }}
                gutterSize='s'
                justifyContent='flexStart'
                wrap
                responsive
            >
                {orderingModes
                    .filter((orderingMode) => orderingMode.status)
                    .map((mode) => {
                        return (
                            <EuiFlexItem key={mode.id.toString()}>
                                <EuiFlexGroup direction='row' justifyContent='flexStart' alignItems='center'>
                                    <EuiFlexItem grow={false}>
                                        <Controller
                                            render={({ field }) => {
                                                return (
                                                    <EuiCheckbox
                                                        onChange={(e) => {
                                                            field.onChange(e.target.checked);
                                                            updateOrderingMode(mode, e);
                                                            setValue(
                                                                `${mode.display_name}_${mode.id}`,
                                                                e.target.checked
                                                            );
                                                        }}
                                                        id={htmlIdGenerator()()}
                                                        checked={Boolean(field.value)}
                                                        compressed
                                                    />
                                                );
                                            }}
                                            name={`choices[${index}].${mode.id}`}
                                            control={control}
                                        />
                                    </EuiFlexItem>
                                    <EuiFlexItem grow={false}>
                                        <EuiText style={{ textTransform: 'capitalize' }}>{mode.display_name}</EuiText>
                                    </EuiFlexItem>
                                </EuiFlexGroup>
                            </EuiFlexItem>
                        );
                    })}
            </EuiFlexGroup>
            <EuiSpacer />
        </>
    );
};

export default React.memo(ChoiceExpose);
